import { FuelIcon } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-gap: ${({ theme: { spacing } }) => spacing.km2};
`;

export const StepNames = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    justify-content: space-between;
    height: ${spacing.km6};
  `}
`;

export const Step = styled.span<{ active: boolean }>`
  ${({ theme: { color, font }, active }) => css`
    display: flex;
    align-items: center;
    color: ${color.icon.success.default};
    height: 100%;

    > span {
      color: ${color.text.neutral[active ? 'strong' : 'default']};
      font-size: ${font.size[active ? 'm5' : 'm4']};
      font-weight: ${font.weight.bold};
    }
  `}
`;

export const StepCompleted = styled(FuelIcon)`
  margin-right: ${({ theme: { spacing } }) => spacing.km1};
`;
